import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @usage
 * <rx-skeleton-form [numberOfItems]="5" [numberOfColumns]="2" style="width: 80vw"/>
 * 
 * @example It will looks like this:
 * [Label]
 * [   Input   ]
 * 
 * [Label]
 * [   Input   ]
 *  
 * @param numberOfItems - The number of items to display,where each item has a label and an input
 * @param numberOfColumns - The number of columns to display,where 1 is a single column and 2 is a two column layout
 * @param inputHeight - The height of the input, default is 3rem
 * @param testId - The test id to be used for the skeleton form, for automation tests detect if the component is loaded
 */
@Component({
  standalone: true,
  selector: 'rx-skeleton-form',
  imports: [CommonModule],
  styleUrls: ['./skeleton-form.component.scss'],
  templateUrl: './skeleton-form.component.html',
})
export class SkeletonFormComponent {
  @Input() numberOfItems = 3;
  @Input() numberOfColumns: 1 | 2 | 3 = 1;
  @Input() testId: string = 'test-loading-form';
  @Input() inputHeight: string = '3rem';

  get gridStyle(): Record<string, string> {
    return {
      'grid-template-columns': `repeat(${this.numberOfColumns}, 1fr)`,
    };
  }

  get arrayOfItems(): number[] {
    return Array.from({ length: this.numberOfItems });
  }
}
